import React, { useEffect } from "react";

import TextInput from "@peracto/peracto-editor-ui/dist/TextInput";
import File from "@peracto/peracto-editor-ui/dist/File";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";

const LinkRowForm = ({
    onChange,
    state: { items = [], selectedItemIndex },
}) => {
    const DEFAULT_CARD = {
        linkImage: "",
        linkHeading: "Heading",
        linkHref: "#",
    };

    useEffect(() => {
        return () => {
            onChange({ selectedItemIndex: null });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {items?.length === 0 && (
                <>
                    <p>Click 'Add Link Row Item' to get started</p>
                    <hr />
                </>
            )}
            {selectedItemIndex !== null &&
                items &&
                items[selectedItemIndex] && (
                    <>
                        <File
                            label="Link Image URL"
                            value={items[selectedItemIndex].linkImage}
                            onChange={(value) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].linkImage = value;

                                onChange({ items: itemsClone });
                            }}
                            isInline={false}
                        />

                        <TextInput
                            label="Link Heading"
                            value={items[selectedItemIndex].linkHeading}
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].linkHeading =
                                    e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />
                        <TextInput
                            label="Link URL"
                            value={items[selectedItemIndex].linkHref}
                            onChange={(e) => {
                                const itemsClone = [...items];
                                itemsClone[selectedItemIndex].linkHref =
                                    e.target.value;

                                onChange({ items: itemsClone });
                            }}
                        />

                        <button
                            className="btn btn-sm btn-danger w-100 mt-2"
                            onClick={(e) => {
                                const itemsClone = [...items];

                                itemsClone.splice(selectedItemIndex, 1);

                                onChange({
                                    items: itemsClone,
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} className="mr-2" />{" "}
                            Remove Link Row Item
                        </button>
                    </>
                )}

            <hr className="my-2" />

            <button
                className="btn btn-sm btn-secondary w-100"
                onClick={(e) => {
                    e.preventDefault();

                    const itemsClone = [...items, DEFAULT_CARD];
                    onChange({
                        items: itemsClone,
                    });
                }}
            >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" /> Add
                Link Row Item
            </button>
        </>
    );
};

export default LinkRowForm;
